import { render, staticRenderFns } from "./InformeSolicitudes.vue?vue&type=template&id=f7e5f2a0&scoped=true"
import script from "./InformeSolicitudes.vue?vue&type=script&lang=js"
export * from "./InformeSolicitudes.vue?vue&type=script&lang=js"
import style0 from "./InformeSolicitudes.vue?vue&type=style&index=0&id=f7e5f2a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e5f2a0",
  null
  
)

export default component.exports